/* Built in import */
import React from 'react';

/* Internal imports */
import RoutesUtils from '../../../../utils/routes/RoutesUtils';
import { ACTIVITY_DOMAINS } from '../../../../utils/constantes/ROUTES/ROUTES';
import { PrivateAppRoute } from '../../../../helpers/routes/PrivateAppRoute';
import { getMaroquinerieArborescence } from './MaroquinerieArborescence';
import TunnelLayout from '../../../../layouts/default/TunnelLayout';

const buildRoute = (path, component, activityDomain) => {
  const routeProps = RoutesUtils.getRoutePropsByDomainAndType(component, TunnelLayout, activityDomain, ACTIVITY_DOMAINS.MAROQUINERIE.NAME);

  return (
    <PrivateAppRoute
      exact
      path={path}
      layout={routeProps.layout}
      component={routeProps.component}
    />);
};

const MaroquineriePrivateRoutes = (activityDomain) => {
  let routesArray = getMaroquinerieArborescence();
  return (
    [
      routesArray.map(route => {
        return(buildRoute(route.path, route.component, activityDomain))
      })
    ]
  )
};

export default MaroquineriePrivateRoutes;